import React from 'react'
import { Col, Container, Row } from 'reactstrap'
import { TableCargos } from './TableCargos'

export function GdCargos() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
            <h3 style={{ marginBottom: 30, color:"#024b82" }}>Gestión de cargos</h3>
        </Col>
      </Row>
      <Row>
        <TableCargos />
      </Row>
    </Container>

  )
}
